import { Input } from '../ui/input';

/**
 * Total Score Entry Component
 * Entry mode for front 9 / back 9 totals
 */
const TotalScoreEntry = ({
  front9,
  back9,
  numberOfHoles,
  onFront9Change,
  onBack9Change,
  disabled = false
}) => {
  const totalScore = (Number(front9) || 0) + (numberOfHoles === 18 ? Number(back9) || 0 : 0);
  const hasTotal = front9 || (numberOfHoles === 18 && back9);

  return (
    <div className="grid grid-cols-3 gap-4">
      {/* Front 9 */}
      <div className="space-y-2">
        <label data-testid="total-entry-first-nine-label" className="text-sm font-medium text-[var(--ps-text-secondary)]">{numberOfHoles === 9 ? 'Selected 9' : 'Front 9'}</label>
        <Input
          type="number"
          value={front9}
          onChange={(e) => onFront9Change(e.target.value)}
          placeholder="--"
          min={1}
          step={1}
          disabled={disabled}
          className="dark-input text-center text-2xl font-mono h-14"
          data-testid="front9-input"
        />
      </div>
      
      {/* Back 9 */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-[var(--ps-text-secondary)]">
          {numberOfHoles === 9 ? 'N/A' : 'Back 9'}
        </label>
        <Input
          type="number"
          value={back9}
          onChange={(e) => onBack9Change(e.target.value)}
          placeholder="--"
          min={1}
          step={1}
          disabled={disabled || numberOfHoles === 9}
          className={`dark-input text-center text-2xl font-mono h-14 ${
            numberOfHoles === 9 ? 'opacity-50 cursor-not-allowed' : ''
          }`}
          data-testid="back9-input"
        />
      </div>
      
      {/* Total */}
      <div className="space-y-2">
        <label className="text-sm font-medium text-[var(--ps-text-secondary)]">Total</label>
        <div data-testid="total-entry-round-total" className={`w-full h-14 text-2xl font-mono font-bold text-center rounded-xl flex items-center justify-center ${
          hasTotal ? 'bg-[var(--ps-primary)]/10 text-[var(--ps-primary)] border-2 border-[var(--ps-primary)]/30' : 'bg-[var(--ps-bg-elevated)] text-[var(--ps-text-muted)]'
        }`}>
          {hasTotal ? totalScore : '--'}
        </div>
      </div>
    </div>
  );
};

export default TotalScoreEntry;
